import * as React from 'react';
import { connect } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedRootSpace } from './RootSpace';

export interface RootSpaceRouterOwnProps extends ReactDirectiveProps {}
export interface RootSpaceRouterStateProps {
  readonly routerReactKey: number;
}
export type RootSpaceRouterProps = RootSpaceRouterOwnProps & RootSpaceRouterStateProps;

export class RootSpaceRouterComponent extends React.PureComponent<RootSpaceRouterProps> {
  public render() {
    return (
      <HashRouter key={'root-space-router-' + this.props.routerReactKey}>
        <ConnectedRootSpace angularContext={this.props.angularContext}/>
      </HashRouter>
    );
  }
}

const mapStateToProps: MapStateToProps<RootSpaceRouterStateProps> = (state: AppState) => ({
  routerReactKey: state.routerSpaceReactKey
});

export const RootSpaceRouter: React.ComponentClass<RootSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, {pure: false})(RootSpaceRouterComponent);
